import _ from 'lodash';
import type { Op } from 'quill/core';
import Quill, { Delta } from 'quill/core';
import QuillHistory, { getLastChangeIndex } from 'quill/modules/history';
import type { TableChange } from './table/types';

class History extends QuillHistory {
  // @ts-expect-error
  quill: Quill;
  // @ts-expect-error
  stack: {
    undo: Delta[];
    redo: Delta[];
  };
  // @ts-expect-error
  lastRecorded: number;
  // @ts-expect-error
  ignoreChange: boolean;

  change(source: 'undo' | 'redo', dest: 'undo' | 'redo') {
    if (this.stack[source].length === 0) return;
    const delta = this.stack[source].pop();
    if (!delta) return;
    const base = this.quill.getContents();
    const inverseDelta = delta.invert(base);
    this.stack[dest].push(inverseDelta);
    this.lastRecorded = 0;
    this.ignoreChange = true;
    this.quill.updateContents(delta, Quill.sources.USER);
    this.ignoreChange = false;
    // The above code is copied from quill's history module.

    const { quill, index } = this.getLastChangePosition(delta);
    quill.setSelection(index, 0);
  }

  getLastChangePosition(delta: Delta): { quill: Quill; index: number } {
    const index = getLastChangeIndex(this.quill.scroll, delta);
    const lastOp = _.last(delta.ops);
    const cell = lastOp && getContentChangedCellForOp(lastOp);
    if (cell) {
      const [leaf] = this.quill.getLeaf(index - 1);
      const cellQuill =
        leaf &&
        'getCellQuill' in leaf &&
        typeof leaf.getCellQuill === 'function'
          ? leaf.getCellQuill(cell.identity)
          : null;

      if (cellQuill) {
        return {
          quill: cellQuill,
          index: getLastChangeIndex(cellQuill.scroll, new Delta(cell.content)),
        };
      }
    }
    return { quill: this.quill, index };
  }
}

function getContentChangedCellForOp(
  op: Op,
): { identity: string; content: Delta } | null {
  const cells: TableChange['cells'] =
    op.retain &&
    typeof op.retain === 'object' &&
    // @ts-expect-error
    op.retain['table-embed']?.cells;
  if (!cells) return null;
  const identities = Object.keys(cells);

  for (let i = identities.length - 1; i >= 0; i -= 1) {
    const identity = identities[i];
    if (identity) {
      const cell = cells[identity];
      if (cell?.content) {
        return { identity, content: new Delta(cell.content) };
      }
    }
  }
  return null;
}

export default History;
